export const SET_ALERT = 'SET_ALERT'
export const DISMISS_ALERT = 'DISMISS_ALERT'
export const SET_SCREEN_SIZE = 'SET_SCREEN_SIZE'
export const SET_NAVBAR_EXPANDED = 'SET_NAVBAR_EXPANDED'
export const SET_NAVBAR_EXPANDED_MOBILE = 'SET_NAVBAR_EXPANDED_MOBILE'